import { apiService } from "@/services";
import { settings } from "@/settings";
import { ProductsClient } from "./GeneratedClients";

const productRepository = new ProductsClient(settings.webApi.baseUrl, apiService.getApiClient());

export { productRepository };

